import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home/home.vue'
import About from '../views/about/about.vue'
import Solution from '../views/solution/solution.vue'
import Partner from '../views/partner/partner.vue'
import Service from '../views/service/service.vue'
import Join from '../views/join/join.vue'
import SolutionDetail from '../views/solutionDetail/solutionDetail.vue'
import Contact from '../views/contact/contact.vue'
import News from '../views/news/news.vue'
import NewsDetail from '../views/newsDetail/newsDetail.vue'
import Cases from '../views/cases/cases.vue'
import CasesDetail from '../views/casesDetail/casesDetail.vue'
import Message from '../views/message/message.vue'
import Policy from '../views/inner/policy.vue'
import Agreement from '../views/inner/agreement'

Vue.use(Router)
//Vue重复点击相同路由
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home
    },
    {
      path: '/message',
      name: '留言',
      component: Message
    },
    {
      path: '/about',
      name: '关于我们',
      component: About
    },
    {
      path: '/solution',
      name: '解决方案',
      component: Solution
    },
    {
      path: '/partner',
      name: '合作伙伴',
      component: Partner
    },
    {
      path: '/service',
      name: '服务支持',
      component: Service
    },
    {
      path: '/join',
      name: '加入我们',
      component: Join
    },
    {
      path: '/solutionDetail',
      name: '方案详情',
      component: SolutionDetail
    },
    {
      path: '/contact',
      name: '联系我们',
      component: Contact
    },
    {
      path: '/news',
      name: '千界资讯',
      component: News
    },
    {
      path: '/newsDetail',
      name: '资讯详情',
      component: NewsDetail
    },
    {
      path: '/cases',
      name: '客户案例',
      component: Cases
    },
    {
      path: '/casesDetail',
      name: '案例详情',
      component: CasesDetail
    },
    {
      path: '/policy',
      name: '政策',
      component: Policy
    },
    {
      path: '/agreement',
      name: '协议',
      component: Agreement
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js